import { Button, Modal, ModalBody } from "reactstrap";

// SDD 039 - Alerta exibido depois do download quando o relatorio saiu com a aba "Avisos".
// So fecha pelo botao OK, para quem gerou nao enviar o arquivo sem conferir.
export default function ModalAvisosRelatorio({ isOpen, onClosed }) {
  return (
    <Modal isOpen={isOpen} backdrop="static" keyboard={false}>
      <ModalBody>
        <h2>Relatório gerado com avisos</h2>
        <hr />
        <p>
          O relatório tem itens sem coluna no modelo, que <strong>não foram somados</strong> nos valores,
          ou itens com unidade diferente da do modelo.
        </p>
        <p>
          Confira a aba <strong>"Avisos"</strong> do arquivo antes de enviar.
        </p>
        <div className="text-right mt-4">
          <Button type="button" color="primary" onClick={onClosed}>OK</Button>
        </div>
      </ModalBody>
    </Modal>
  )
}
